(function () {
  'use strict';

  var AUTOPLAY_DELAY = 3000;
  var SELECTORS = [
    { root: '.mobile-home-hero-carousel', track: '.mobile-home-hero-carousel__track', slide: '.mobile-home-hero--slide' },
    { root: '.mobile-home-foundations', track: '.mobile-home-foundations__track', slide: '.mobile-home-foundations__slide' },
    { root: '.mobile-home-card-carousel', track: '.mobile-home-card-carousel__track', slide: '.mobile-home-card-carousel__slide' },
    { root: '.mobile-home-icons', track: '.mobile-home-icons__track', slide: '.mobile-home-icons__slide' },
    { root: '.mobile-home-actifs', track: '.mobile-home-actifs__track', slide: '.mobile-home-actifs__slide' },
    { root: '.product-luxury-view__carousel', track: '.product-luxury-view__track', slide: '.product-luxury-view__slide' },
    { root: 'product-recommendations', track: '.resource-list--grid', slide: '.resource-list__item' }
  ];

  function chevron(direction) {
    var path = direction === 'previous' ? 'M9 3 4 8l5 5' : 'm7 3 5 5-5 5';
    return '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';
  }

  function button(direction, label) {
    var element = document.createElement('button');
    element.type = 'button';
    element.className = 'najju-slider-arrow najju-slider-arrow--' + direction;
    element.setAttribute('aria-label', label);
    element.innerHTML = chevron(direction);
    return element;
  }

  function initSlider(root, config) {
    if (!root || root.dataset.najjuSliderReady === 'true') return;

    var track = root.querySelector(config.track);
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll(config.slide)) : [];
    if (!track || slides.length < 2) return;

    root.dataset.najjuSliderReady = 'true';

    var language = (document.documentElement.lang || '').toLowerCase();
    var isFrench = language.indexOf('fr') === 0;
    var shell = document.createElement('div');
    shell.className = 'najju-slider-shell';
    track.parentNode.insertBefore(shell, track);
    shell.appendChild(track);

    var controls = document.createElement('div');
    controls.className = 'najju-slider-controls';
    controls.setAttribute('data-najju-slider-controls', '');
    var previous = button('previous', isFrench ? 'Diapositive précédente' : 'Previous slide');
    var next = button('next', isFrench ? 'Diapositive suivante' : 'Next slide');
    controls.appendChild(previous);
    controls.appendChild(next);
    shell.appendChild(controls);

    var timer = null;
    var resumeTimer = null;
    var hovering = false;
    var focusWithin = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function positions() {
      var maximum = maxScroll();
      var values = [];

      slides.forEach(function (slide) {
        if (window.getComputedStyle(slide).scrollSnapAlign === 'none') return;
        var left = slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        left = Math.max(0, Math.min(maximum, left));
        if (!values.some(function (value) { return Math.abs(value - left) < 2; })) values.push(left);
      });

      if (!values.length) values.push(0);
      if (maximum > 4 && !values.some(function (value) { return Math.abs(value - maximum) < 2; })) values.push(maximum);
      return values.sort(function (a, b) { return a - b; });
    }

    function currentIndex(values) {
      var best = 0;
      var distance = Infinity;
      values.forEach(function (value, index) {
        var nextDistance = Math.abs(track.scrollLeft - value);
        if (nextDistance < distance) {
          best = index;
          distance = nextDistance;
        }
      });
      return best;
    }

    function canMove() {
      return maxScroll() > 4 && positions().length > 1;
    }

    function go(direction) {
      var values = positions();
      if (values.length < 2) return;
      var index = currentIndex(values);
      var target = (index + direction + values.length) % values.length;
      track.scrollTo({ left: values[target], behavior: 'smooth' });
    }

    function isPaused() {
      return hovering || focusWithin || document.hidden || reduceMotion.matches || !canMove();
    }

    function clearAutoplay() {
      if (timer) window.clearTimeout(timer);
      timer = null;
    }

    function scheduleAutoplay() {
      clearAutoplay();
      if (isPaused()) return;
      timer = window.setTimeout(function () {
        go(1);
        scheduleAutoplay();
      }, AUTOPLAY_DELAY);
    }

    function pauseTemporarily() {
      clearAutoplay();
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(scheduleAutoplay, AUTOPLAY_DELAY);
    }

    function refresh() {
      controls.hidden = !canMove();
      scheduleAutoplay();
    }

    previous.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      go(-1);
      pauseTemporarily();
    });

    next.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      go(1);
      pauseTemporarily();
    });

    root.addEventListener('mouseenter', function () {
      hovering = true;
      clearAutoplay();
    });
    root.addEventListener('mouseleave', function () {
      hovering = false;
      scheduleAutoplay();
    });
    root.addEventListener('focusin', function () {
      focusWithin = true;
      clearAutoplay();
    });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) {
        focusWithin = false;
        scheduleAutoplay();
      }
    });

    track.addEventListener('pointerdown', pauseTemporarily, { passive: true });
    track.addEventListener('touchstart', pauseTemporarily, { passive: true });
    track.addEventListener('wheel', pauseTemporarily, { passive: true });
    track.addEventListener('keydown', pauseTemporarily);
    document.addEventListener('visibilitychange', scheduleAutoplay);

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', scheduleAutoplay);
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(scheduleAutoplay);
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(refresh).observe(track);
    } else {
      window.addEventListener('resize', refresh);
    }

    refresh();
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    SELECTORS.forEach(function (config) {
      context.querySelectorAll(config.root).forEach(function (root) {
        initSlider(root, config);
      });
      if (context.matches && context.matches(config.root)) initSlider(context, config);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (document.body.classList.contains('template-product')) {
    var mutationTimer = null;
    new MutationObserver(function () {
      if (mutationTimer) window.clearTimeout(mutationTimer);
      mutationTimer = window.setTimeout(function () {
        initAll(document);
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
